import { invenioConfig } from "@config";
import { Identifiers } from "@modules/Identifiers";
import { LiteratureMetadataExtensions } from "@modules/Literature/LiteratureMetadataExtensions";
import LiteratureRelations from "@modules/Literature/LiteratureRelations";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { Tab } from "semantic-ui-react";
import { SpecialCollectionInfo } from "./SpecialCollectionInfo";

class SpecialCollectionMetadataTabs extends Component {
  renderTabPanes = () => {
    const { metadata } = this.props;
    const identifiers = _get(metadata, "identifiers", []);
    const altIdentifiers = _get(metadata, "alternative_identifiers", []);
    const relations = _get(metadata, "relations", {});

    const panes = [
      {
        menuItem: "Details",
        render: () => (
          <Tab.Pane>
            <LiteratureRelations relations={relations} />
            <SpecialCollectionInfo metadata={metadata} />
          </Tab.Pane>
        ),
      },
      {
        // menuItem: 'Identifiers',
        render: () => (
          <Tab.Pane>
            <Overridable id="SpecialCollectionMetadataTabs.Identifiers">
              <Identifiers identifiers={identifiers.concat(altIdentifiers)} />
            </Overridable>
          </Tab.Pane>
        ),
      },
    ];

    const { extensions = {} } = metadata;
    if (
      !_isEmpty(extensions) &&
      !_isEmpty(invenioConfig.SPECIAL_COLLECTIONS?.extensions?.fields)
    ) {
      panes.push({
        menuItem: invenioConfig.SPECIAL_COLLECTIONS.extensions.label,
        render: () => (
          <Tab.Pane>
            <Overridable
              id="SpecialCollectionMetadataTabs.Extensions"
              extensions={extensions}
            />
            <LiteratureMetadataExtensions
              metadataExtensions={extensions}
              configuredExtensions={
                invenioConfig.SPECIAL_COLLECTIONS.extensions
              }
            />
          </Tab.Pane>
        ),
      });
    }
    return panes;
  };

  onTabChange = (event, { activeIndex }) => {
    const { showTab } = this.props;
    showTab(activeIndex);
  };

  render() {
    const { activeTab } = this.props;
    return (
      <Tab
        activeIndex={activeTab}
        menu={{ secondary: true, pointing: true }}
        panes={this.renderTabPanes()}
        onTabChange={this.onTabChange}
        id="special-collection-metadata-section"
        className="special-collection-metadata-tabs"
      />
    );
  }
}

SpecialCollectionMetadataTabs.propTypes = {
  activeTab: PropTypes.number,
  metadata: PropTypes.object.isRequired,
  showTab: PropTypes.func.isRequired,
};

SpecialCollectionMetadataTabs.defaultProps = {
  activeTab: 0,
};

export default Overridable.component(
  "SpecialCollectionMetadataTabs",
  SpecialCollectionMetadataTabs
);
